module.exports = __webpack_public_path__ + "img/ES.5cbdfd18.svg";